import InfoIcon from '@jetbrains/icons/info.svg'
import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import classNames from 'classnames'
import {useRef} from 'react'

import useIntersectionSelector from '../../../../hooks/useIntersectionSelector'
import IconButton from '../../../common/IconButton/IconButton'
import Popup from '../../../common/Popup/Popup.lazy'
import SvgIcon from '../../../common/SvgIcon/SvgIcon'
import RuleItemStyles from '../Listings/Rules/RulesList/RuleItem/RuleItem.css'

import styles from './StickyHeader.css'

const popupProps = {
  directions: [Directions.BOTTOM_CENTER],
}
type Props = {
  name: string
  description: string
  isFirst: boolean
}

function StickyHeader({name, description, isFirst}: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const isStuck = useIntersectionSelector(
    ref,
    entry => {
      const top = entry?.intersectionRect.top
      return top != null && top <= 1
    },
    {
      threshold: 1,
      rootMargin: '-1px',
    },
  )
  const isScrolled = useIntersectionSelector(
    ref,
    entry => {
      const top = entry?.boundingClientRect.top
      return top != null && top < 0
    },
    {
      threshold: 1,
    },
  )
  return (
    <div
      ref={ref}
      className={classNames(styles.headerContainer, {
        [styles.stuck]: isStuck && !isScrolled,
      })}
    >
      <div className={styles.innerContainer}>
        <h2 className={styles.projectName}>{name}</h2>
        {description.length > 0 && <p className={styles.projectDescription}>{description}</p>}
        <div
          className={classNames({
            [styles.invisible]: !isFirst && !isStuck,
          })}
        >
          <div className={classNames(RuleItemStyles.row, styles.row)}>
            <div className={classNames(RuleItemStyles.col, RuleItemStyles.icons)} />
            <div className={classNames(RuleItemStyles.col, RuleItemStyles.limits)}>{'Keep'}</div>
            <div className={classNames(RuleItemStyles.col, RuleItemStyles.filters)}>
              {'Filters'}
            </div>
            <div className={classNames(RuleItemStyles.col, RuleItemStyles.what)}>
              <span id="what-label">{'What to preserve'}</span>
              <Dropdown
                hoverMode
                hoverShowTimeOut={0}
                anchor={
                  <IconButton
                    aria-labelledby="what-label"
                    className={styles.whatIcon}
                    icon={InfoIcon}
                    title=""
                  />
                }
              >
                <Popup {...popupProps} className={styles.infoPopup}>
                  {'S – Statistics'}
                  <br />
                  {'H – History'}
                  <br />
                  {'L – Logs'}
                  <br />
                  {'A – Artifacts'}
                  <br />
                  {'A'}
                  <SvgIcon className={styles.modifiedIcon} icon="modified-10px" />
                  {' – Artifact patterns'}
                  <br />
                  {'D – Artifact dependencies'}
                </Popup>
              </Dropdown>
            </div>
            <div className={classNames(RuleItemStyles.col, RuleItemStyles.actions)} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default StickyHeader
